import { render } from "./DisclaimerHyperlink.vue?vue&type=template&id=74c1445c&scoped=true"
import script from "./DisclaimerHyperlink.vue?vue&type=script&lang=js"
export * from "./DisclaimerHyperlink.vue?vue&type=script&lang=js"

import "./DisclaimerHyperlink.vue?vue&type=style&index=0&id=74c1445c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c1445c"]])

export default __exports__